/* src/services/AppointmentService.js */
import apiClient from './api'

export const AppointmentService = {

  async getAll(params = {}) { 

    try {

      const response = await apiClient.get('booking/list/', { params })
      const rawData = Array.isArray(response.data) ? response.data : response.data.results

      if (!rawData) return []

      return rawData.map(item => {

        console.log("DEBUG - ITEM COMPLETO:", item)

        const parseDateParts = (dateStr) => {
      
          if (!dateStr || typeof dateStr !== 'string') return ['', '']
      
          const parts = dateStr.replace('T', ' ').split(' ')
          const d = parts[0] || ''
          const t = parts[1] ? parts[1].substring(0, 5) : ''
          return [d, t]
        }

        const [datePart, timeStart] = parseDateParts(item.date_start)
        const [_, timeEnd] = parseDateParts(item.date_end)

        return {
          id: item.id,
          cliente: item.customer_name,
          data: datePart,
          orainizio: timeStart,
          orafine: timeEnd,
          status: item.status === 'pending' ? 'In Attesa' : 
                  item.status === 'confirmed' ? 'Confermato' : 
                  item.status === 'cancelled' ? 'Annullato' : item.status,
          note: item.notes || '',
          importoTotale: parseFloat(item.total_amount) || 0,
          importoPagato: parseFloat(item.paid_amount) || 0,
          stato: item.payment_status === 'partial' ? 'Pagamento parziale' :
                 item.payment_status === 'paid' ? 'Saldato' :
                 item.payment_status === 'refunded' ? 'Rimborsato' : 'Da pagare'
        }
      })
    } 
    catch (error) {

      console.error("Errore nel recupero appuntamenti:", error)
      throw error
    }
  },

  mapToApi(form) {
    
    const dateStart = form.data && form.orainizio ? `${form.data}T${form.orainizio}:00` : null;
    const dateEnd = form.data && form.orafine ? `${form.data}T${form.orafine}:00` : null;
    const paymentStatusMap = {
      'Da pagare': 'to_pay',
      'Pagamento parziale': 'partial',
      'Saldato': 'paid',
      'Rimborsato': 'refunded'
    }

    return {
      customer_name: form.cliente,
      date_start: dateStart,
      date_end: dateEnd,
      status: form.status === 'Confermato' ? 'confirmed' : 
              form.status === 'Annullato' ? 'cancelled' : 'pending',
      notes: form.note,
      total_amount: parseFloat(form.importoTotale) || 0,
      paid_amount: parseFloat(form.importoPagato) || 0,
      payment_status: paymentStatusMap[form.stato] || 'to_pay'
    }
  },

  async update(id, formData) {
    const payload = this.mapToApi(formData)
    const response = await apiClient.put(`booking/list/${id}/`, payload)
    return response.data
  },

  async create(formData) {
    const payload = this.mapToApi(formData)
    const response = await apiClient.post('booking/list/', payload)
    return response.data
  },

  async delete(id) {
    await apiClient.delete(`booking/list/${id}/`)
  }
}